import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const HonoreeCollage = () => {
  const [honorees, setHonorees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHonorees = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/honorees`);
        // Shuffle the honorees for variety
        const shuffled = response.data.sort(() => Math.random() - 0.5);
        setHonorees(shuffled);
      } catch (err) {
        console.error('Error fetching honorees:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchHonorees();
  }, []);

  if (loading || honorees.length === 0) {
    return null;
  }

  // Filter honorees with images
  const honoreesWithImages = honorees.filter(h => h.image);

  return (
    <section className="py-16 bg-[#0a0a0b] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
            Live Long And Prosper
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-amber-500 mb-6">
            Share Your Vulcan Salute!
          </h3>
          <p className="text-gray-300 max-w-2xl mx-auto mb-4">
            Please share your Vulcan Salute honoring Leonard Nimoy on Feb. 27, the 10th anniversary of his passing.
          </p>
          <p className="text-amber-500 font-medium">
            Use hashtags <span className="text-white">#LLAP</span> <span className="text-white">#RememberingLeonardNimoy</span> <span className="text-white">#NimoyKnightFoundation</span>
          </p>
        </div>

        {/* Collage Grid */}
        <div className="relative">
          {/* Main Collage - Responsive Grid */}
          <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 gap-1 md:gap-2">
            {honoreesWithImages.slice(0, 32).map((honoree, index) => (
              <Link
                key={honoree.id}
                to={`/honorees/${honoree.id}`}
                className="relative aspect-square overflow-hidden rounded-lg group"
                title={honoree.name}
              >
                <img
                  src={honoree.image}
                  alt={honoree.name}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-2">
                  <span className="text-white text-xs font-medium text-center line-clamp-2">
                    {honoree.name}
                  </span>
                </div>
                {/* Amber border on hover */}
                <div className="absolute inset-0 border-2 border-amber-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg" />
              </Link>
            ))}
          </div>

          {/* Gradient Fade on edges */}
          <div className="absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-[#0a0a0b] to-transparent pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-[#0a0a0b] to-transparent pointer-events-none" />
        </div>

        {/* View All Button */}
        <div className="text-center mt-10">
          <Link
            to="/honorees"
            className="inline-flex items-center gap-2 px-8 py-3 bg-transparent border-2 border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black font-semibold rounded-full transition-all"
          >
            View All Honorees
            <span className="text-lg">🖖</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HonoreeCollage;
